import { useTranslation } from "react-i18next";
import type { WorkflowDataQuery } from "./models";
export function DataQuerySummary({ query, timezone }: { query?: WorkflowDataQuery | null; timezone?: string }) {
    const { t } = useTranslation();
    if (!query) return null;
    const text = (key: string, fallback: string) => t(`workflowData.${key}`, { defaultValue: fallback });
    const period = query.planning_period;
    return <dl>
        {period && period.kind !== "all" && <div><dt>{text("planningPeriod", "Planning period")}</dt><dd>{period.kind === "absolute" ? `${period.start} – ${period.end}` : `${text(`planning_${period.kind}`, period.kind)}${period.kind === "next_days" ? ` · ${period.count}` : ""}`} · {timezone ?? "Europe/Stockholm"}</dd></div>}
        {query.workspace_status !== "all" && <div><dt>{text("taskStatus", "Workspace status")}</dt><dd>{text(`status_${query.workspace_status}`, query.workspace_status)}</dd></div>}
    </dl>;
}
